module.exports = __webpack_public_path__ + "static/media/GUIDE_0013_03.f6f27ebb.webp";